import { first } from 'lodash';
import { feature } from 'topojson-client';

/**
 * This function will attempt to cast a topojson object to a geojson feature
 * This will return the object as-is if it's not a topojson object
 * @param {Object} json JSON object which we're going to convert
 * @returns {Object} A geojson feature
 */
export function topojsonToGeojson(json) {
  if (!json || !json.objects) {
    return json;
  }

  const objectKey = first(Object.keys(json.objects));
  return feature(json, json.objects[objectKey]);
}

export default topojsonToGeojson;
